import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import i18n from './i18n'

Vue.use(Vuetify)

const opts = {
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    options: {
      customProperties: true
    },
    dark: false,
    themes: {
      light: {
        primary: '#072a67',
        complimentary: '#d88f0f',
        secondary: '#00d4ff',
        accent: '#FF9FE9',
        accent2: '#FFF7D6',
        accent3: '#b4c7e7',
        error: colors.red.accent3,
        marcColor: '#b23127',
      }
    }
  }
}

export default new Vuetify(opts)
